import React from 'react'
import PropTypes from 'prop-types'
import PopoverLayout from './popover_layout'
import ChatConversationActionsList from '../chat_conversation_actions_list'

class ChatConversationOptionsPopover extends React.PureComponent {

  render() {
    const {
      isXS,
      onClose,
      isChatConversationRequest,
      chatConversationId,
    } = this.props
    
    return (
      <PopoverLayout
        width={220}
        isXS={isXS}
        onClose={onClose}
      >
        <ChatConversationActionsList
          size={isXS ? 'small' : 'large'}
          chatConversationId={chatConversationId}
          isChatConversationRequest={isChatConversationRequest}
        />
      </PopoverLayout>
    )
  }

}

ChatConversationOptionsPopover.propTypes = {
  chatConversationId: PropTypes.string,
  isXS: PropTypes.bool,
  isChatConversationRequest: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
}

export default ChatConversationOptionsPopover